/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolHotelIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-hotel"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M1.68 19.65Q1.13 19.65 0.74 19.26Q0.35 18.88 0.35 18.32L0.35 4.78Q0.35 4.22 0.74 3.84Q1.13 3.45 1.68 3.45Q2.23 3.45 2.61 3.84Q3 4.22 3 4.78L3 13.95L11 13.95L11 8.15Q11 7.03 11.76 6.26Q12.53 5.5 13.65 5.5L19.15 5.5Q21.02 5.5 22.34 6.81Q23.65 8.13 23.65 10L23.65 18.32Q23.65 18.88 23.26 19.26Q22.88 19.65 22.32 19.65Q21.77 19.65 21.39 19.26Q21 18.88 21 18.32L21 16.6L3 16.6L3 18.32Q3 18.88 2.61 19.26Q2.23 19.65 1.68 19.65ZM7 13.2Q7 13.2 6.29 13.2Q5.58 13.2 4.58 12.2Q3.58 11.2 3.58 9.78Q3.58 8.35 4.58 7.35Q5.58 6.35 7 6.35Q8.43 6.35 9.43 7.35Q10.43 8.35 10.43 9.78Q10.43 11.2 9.43 12.2Q8.43 13.2 7 13.2Z" fill={color} />
    </svg>
  );
}
